import React, { useState, useEffect, useRef } from 'react'

import {
    Button,
    Card, Collapse, Grid, Paper, Typography, Select,
    FormHelperText, Dialog, Icon, Switch
} from "@material-ui/core";

import useStyles from "./styles";

import { InputBaseField, SelectField } from "../../../../components/InputField/InputField";
import { CustomBtn, Label, DraggableComponent } from "../../../../components/UiElements/UiElements";
import profilePlaceholder from '../../../../assets/img/profilePlaceholder.jpg';
import Envelope from '../../../../assets/img/action/email-icon.svg';
import CallIcon from '../../../../assets/img/action/call-icon.svg';
import CalendarToday from '../../../../assets/img/icons/calendarToday.svg';
//import Location from '../../assets/img/icons/map-marker-Bold.svg';
import { GetUserInfo } from "../../../../Services/GetUserInfo";
import { PostDataAPI } from '../../../../Services/APIService';
import EditPen from '../../../../assets/img/action/penWhite.svg';
import Loader from './../../../../components/Loader/Loader';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import TopSpacer from '../../../../components/Common/spacer/TopSpacer';
import { withSnackbar } from "./../../../../components/Message/Alert";
import { formateMdnNumber, getAgeByDOBInYears, validatePhoneNumber, handleNumberKeyPress, allowedAttachmentsImages, validateEmail, validateDateOfBirth, formatDate, getFormatedDate, saveActivlityLogInfo } from '../../../../components/Common/Extensions';
import Breadcrums from '../../../../components/BreadCrums/breadcrums';
import { useLocation, useParams, useHistory } from "react-router-dom";
import { lstStates, lstCountry, lstMonths } from '../../../../components/Common/Lookup';
import CloseIcon from '@material-ui/icons/Close';
import { Scrollbars } from 'rc-scrollbars';
import { ActionDialog } from "../../../../components/ActionDialog/ActionDialog";
function AddNewUser({ dialogOpenClose, handleClose, handleSuccessClose, data, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const commonAttachments = allowedAttachmentsImages();
    const [isLoading, setIsLoading] = useState(false);
    let user_info = JSON.parse(GetUserInfo());
    const [isCorporateOwner, setIsCorporateOwner] = useState(false);
    const [state, setState] = useState({ firstName: '', lastName: '', emailAddress: '', password: '', isCorporateOwner: false });
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    let history = useHistory();
    const [errorMessages, setErrorMessages] = useState({});

    const [profileImage, setProfileImage] = useState({ file: null, fileToSend: null, fileName: null });
    function uploadSingleFile(e) {
        if (e.target.files == null || e.target.files.length <= 0)
            return
        const name = e.target.files[0].name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                logUserDialogActivity(
                    "User Photo Upload Rejected",
                    `User selected an unsupported profile photo file for ${getDialogUserSummary()}`
                );
                return;
        }
        setProfileImage({
            file: URL.createObjectURL(e.target.files[0]),
            fileToSend: e.target.files[0],
            fileName: e.target.files[0].name
        })
        logUserDialogActivity(
            "User Photo Selected",
            `User selected a profile photo for ${getDialogUserSummary()}`
        );
    }

    const inputFile = useRef(null);

    const uploadFile = () => {

        logUserDialogActivity(
            "User Photo Upload Opened",
            `User opened profile photo upload for ${getDialogUserSummary()}`
        );
        inputFile.current.click();
    };

    const [roles, setRoles] = useState([]);

    //const Occupation = [
    //    {
    //        label: 'Select Occupation',
    //        value: ''
    //    },
    //    {
    //        label: "Engineer",
    //        value: "Engineer",
    //    },
    //    {
    //        label: "Doctor",
    //        value: "Doctor",
    //    },
    //]

    const Gender = [
        { label: 'Select Gender', value: '' },
        {
            label: "Male",
            value: "Male",
        },
        {
            label: "Female",
            value: "Female",
        },
    ]



    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const handleToggle = (event) => {
        const { checked } = event.target;
        if (checked) {
            debugger
            logUserDialogActivity(
                "Corporate Owner Confirmation Opened",
                `User opened corporate owner confirmation for ${getDialogUserSummary()}`
            );
            const message = "Enabling this will replace the current corporate owner, and admin notifications will be sent to this user. Are you sure you want to proceed?";
            showActionDialog(message, "confirm", function () {
                logUserDialogActivity(
                    "Corporate Owner Toggle Confirmed",
                    `User confirmed corporate owner assignment for ${getDialogUserSummary()}`
                );
                setState(prevState => ({
                    ...prevState,
                    "isCorporateOwner": true
                }));
            });
        }
        else {
            debugger
            logUserDialogActivity(
                "Corporate Owner Toggle Disabled",
                `User disabled corporate owner flag for ${getDialogUserSummary()}`
            );
            setState(prevState => ({
                ...prevState,
                "isCorporateOwner": false
            }));
        }

    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleChangeWithTrim = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value?.trim()
        }));
    }

    const handleDigitFieldChange = e => {
        const { name, value } = e.target;
        const sanitizedValue = value.replace(/\D/g, '');
        setState(prevState => ({
            ...prevState,
            [name]: sanitizedValue
        }));
    }


    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {

                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }

    const ValidateRecord = (errorList) => {
        if (!state.firstName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: false
            }));
        }
        if (!state.lastName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorLastName: false
            }));
        }

        if (!state.emailAddress || !validateEmail(state.emailAddress)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }

        if (!state.password) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPassword: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPassword: false
            }));
        }
        if (state.password != state.confirmPassword) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorConfirmPassword: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorConfirmPassword: false
            }));
        }
        if (!state.phoneNumber) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneNumber: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneNumber: false
            }));
        }
        if ((state.phoneNumber && !validatePhoneNumber(state.phoneNumber))) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhoneNumber: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhoneNumber: false
            }));
        }

        if (!state.roleId) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRole: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRole: false
            }));
        }


        //var toDay = toDayDate();
        //if (!state.dateOfBirth || state.dateOfBirth.trim() === "") {

        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorDOB: true
        //    }));

        //    errorList.push(true);

        //}
        //else if (state.dateOfBirth && state.dateOfBirth > toDay) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorDOBFuture: true
        //    }));

        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorDOB: false
        //    }));
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorDOBFuture: false
        //    }));
        //}

        //if (!state.gender) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorGender: true
        //    }));
        //    errorList.push(true);
        //} else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorGender: false
        //    }));
        //}

        ////address validation

        //if (!state.address1) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorAddress1: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorAddress1: false
        //    }));
        //}

        ////if (!state.address2) {
        ////    setErrorMessages(prevState => ({
        ////        ...prevState,
        ////        errorAddress2: true
        ////    }));
        ////    errorList.push(true);
        ////}
        ////else {
        ////    setErrorMessages(prevState => ({
        ////        ...prevState,
        ////        errorAddress2: false
        ////    }));
        ////}

        //if (!state.city) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorCity: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorCity: false
        //    }));
        //}

        //if (!state.state) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorState: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorState: false
        //    }));
        //}

        //if (!state.zipCode) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorZipCode: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorZipCode: false
        //    }));
        //}

        //if (!state.homeContactName) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorHomeName: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorHomeName: false
        //    }));
        //}

        //if (!state.homePhone || (state.homePhone && !validatePhoneNumber(state.homePhone))) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorHomePhone: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorHomePhone: false
        //    }));
        //}




    }

    const updateUserProfileDetails = () => {
        const isUpdate = state.userId > 0;
        logUserDialogActivity(
            isUpdate ? "User Update Button Clicked" : "User Add Button Clicked",
            `User clicked ${isUpdate ? "Update" : "Add New"} for ${getDialogUserSummary()}`
        );
        let errorList = [];
        ValidateRecord(errorList);
        if (errorList.length < 1) {

            const formData = new FormData();
            formData.append("associateId", associateId);
            formData.append("accountNumber", accountNumber);
            let method = "fwuser/add";
            let successMessage = "User added successfully.";
            if (isUpdate) {
                method = "fwuser/update";
                successMessage = "User updated successfully.";
            }

            for (var key in state) {
                if (state[key] && key != "fileToSend"
                    && key != "photoName"
                    && key != "encUserID"
                )
                    formData.append(key, state[key]);
            }
            formData.append("photoFile", profileImage.fileToSend);
            formData.append("photoName", profileImage.fileName);
            formData.append("CompanyName", companyName);
            setIsLoading(true);

            PostDataAPI(method, formData, true, "formData").then((result) => {
                debugger
                setIsLoading(false);
                if (result.success == true) {
                    setErrorMessages([]);
                    //updateUserSessionInfo();
                    handleSuccessClose(successMessage);
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
            })
        }
        else {
            logUserDialogActivity(
                isUpdate ? "User Update Validation Failed" : "User Add Validation Failed",
                `User attempted to ${isUpdate ? "update" : "add"} ${getDialogUserSummary()}, but required fields failed validation: ${getValidationErrorSummary()}`
            );
        }

    }

    const getLoginUserDetails = () => {

        var obj = { userID: data.userId };
        setIsLoading(true);
        PostDataAPI("fwuser/getUserDetails", obj, true).then((result) => {
            if (result.success && result.data != null) {
                result.data.dateOfBirth = result.data.dateOfBirth?.split('T')[0];
                setState(result.data);
                setIsCorporateOwner(result.data.isCorporateOwner)
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }

    function toDayDate() {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + '-' + mm + '-' + dd;
        return today;
    }
    const userInfoJson = sessionStorage.getItem('user_info');
    const userInfo = JSON.parse(userInfoJson);
    const associateId = userInfo.user.associateId;
    const accountNumber = userInfo.user.accountNumber;
    const companyName = userInfo.user.corporateName;
    const getDialogUserName = () => {
        const name = `${state?.firstName || data?.firstName || ""} ${state?.lastName || data?.lastName || ""}`.trim();
        return name || "selected user";
    };
    const getDialogUserSummary = () => {
        const parts = [`user ${getDialogUserName()}`];
        const userId = state?.userId || data?.userId;
        const email = state?.emailAddress || data?.emailAddress;
        const phone = state?.phoneNumber || data?.phoneNumber;
        if (userId)
            parts.push(`User ID: ${userId}`);
        if (email)
            parts.push(`Email: ${email}`);
        if (phone)
            parts.push(`Phone: ${phone}`);
        return parts.join(", ");
    };
    const logUserDialogActivity = (activity, details) => {
        saveActivlityLogInfo("User Setup", activity, details, accountNumber, associateId);
    };
    const getValidationErrorSummary = () => {
        const errors = [];
        if (!state.firstName)
            errors.push("first name");
        if (!state.lastName)
            errors.push("last name");
        if (!state.emailAddress || !validateEmail(state.emailAddress))
            errors.push("valid email address");
        if (!state.password)
            errors.push("password");
        if (state.password != state.confirmPassword)
            errors.push("matching confirm password");
        if (!state.phoneNumber)
            errors.push("phone number");
        if (state.phoneNumber && !validatePhoneNumber(state.phoneNumber))
            errors.push("valid phone number");
        if (!state.roleId)
            errors.push("role");

        return errors.length ? errors.join(", ") : "validation errors";
    };
    const initializations = () => {
        var params = {
            roleType: 'customer_portal',
            customerId: associateId,
            loadDefault: "true"
        };
        PostDataAPI("fwrole/loadGrid", params).then((result) => {
            if (result.success && result.data != null) {
                setRoles(prevState => [...prevState, { value: '', label: 'Select Roles' }]);
                result.data.map((item, i) => {
                    setRoles(prevState => [...prevState, { value: item.roleId, label: item.roleName }]);
                })
            }
        })
    }

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        initializations();
        if (data && data.userId > 0) {
            getLoginUserDetails();
        }
    }, []);

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            {...props} >
            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>{data.userId > 0 ? 'Update User' : 'Add User'}</Typography>

                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                    <Scrollbars autoHeight autoHeightMax={570}>
                        <div>
                            <div className={classes.informationSec}>

                                <div className={classes.profileImg}>
                                    {profileImage.file || state.userPhotoPath ?
                                        <>
                                            <img src={profileImage.file ? profileImage.file : '.' + state.userPhotoPath} className='profile-image' />
                                        </>
                                        : <img src={profilePlaceholder} className='profile-image' />
                                        // <div className="user-profile-page" style={{ backgroundImage: 'URL(' + profilePlaceholder + ')' }}></div>
                                    }
                                    <img className={classes.EditICon} src={EditPen} onClick={uploadFile} />
                                    <form>
                                        <div>
                                            <input type="file" id="fileUploadField" ref={inputFile} className={classes.inputFile} onChange={uploadSingleFile} accept=".png, .jpg, .jpeg" style={{ display: "none" }} />
                                        </div>
                                    </form>
                                </div>

                                <Grid container className={classes.formContaner}>

                                    <Grid lg={6} md={6} sm={12} xs={12} className="p-right-ten">
                                        <Grid row >
                                            <Label item title="First Name" size={12} mandatory={true} />
                                            <Grid lg={12} md={12} sm={12}>
                                                <InputBaseField
                                                    name="firstName"
                                                    type="text"
                                                    placeholder="First Name"
                                                    MaxLength="50"
                                                    value={state.firstName}
                                                    onChange={handleChange}
                                                />
                                                {errorMessages.errorFirstName && !state.firstName ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter first name
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>

                                    </Grid>


                                    <Grid lg={6} md={6} sm={12} xs={12} className="p-right-ten">
                                        <Grid row >
                                            <Label item title="Last Name" size={12} mandatory={true} />
                                            <Grid lg={12} md={12} sm={12}>
                                                <InputBaseField
                                                    name="lastName"
                                                    type="text"
                                                    placeholder="Last Name"
                                                    MaxLength="50"
                                                    value={state.lastName}
                                                    onChange={handleChange}
                                                />
                                                {errorMessages.errorLastName && !state.lastName ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter last name
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    <Grid lg={6} md={6} sm={12} xs={12}>

                                        <Grid row>
                                            <Label item title="Email address" size={12} mandatory={true} />
                                            <Grid lg={12} md={12} sm={12}>
                                                <InputBaseField
                                                    name="emailAddress"
                                                    type="email"
                                                    placeholder="Email Address"
                                                    MaxLength="100"
                                                    value={state.emailAddress}
                                                    onChange={handleChangeWithTrim}
                                                />
                                                {errorMessages.errorEmailAddress && (!state.emailAddress || !validateEmail(state.emailAddress)) ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter valid email address
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid lg={6} md={6} sm={12} xs={12}>

                                        <Grid row>
                                            <Label item title="Phone Number" size={12} mandatory={true} />
                                            <Grid lg={12} md={12} sm={12}>
                                                <InputBaseField
                                                    name="phoneNumber"
                                                    type="phone"
                                                    placeholder="Phone number"
                                                    MaxLength={14}
                                                    value={state.phoneNumber}
                                                    onChange={handlePhoneChange}
                                                />
                                                {errorMessages.errorPhoneNumber && !state.phoneNumber ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter phone number
                                                </FormHelperText>) : ('')}
                                                {errorMessages.errorInvalidPhoneNumber && (state.phoneNumber && !validatePhoneNumber(state.phoneNumber)) ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter valid phone number
                                                </FormHelperText>) : ('')}

                                            </Grid>
                                        </Grid>

                                    </Grid>

                                    <Grid lg={6} md={6} sm={12} xs={12} className="p-right-ten">
                                        <Grid row >
                                            <Label item title="Password" size={12} mandatory={true} />
                                            <Grid lg={12} md={12} sm={12}>
                                                <InputBaseField
                                                    name="password"
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Password"
                                                    MaxLength="20"
                                                    value={state.password}
                                                    onChange={handleChangeWithTrim}
                                                    enablePasswordToggle={true}
                                                />
                                                {errorMessages.errorPassword && !state.password ? (<FormHelperText style={{ color: "red" }} >
                                                    Please enter password
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                    <Grid item lg={6} md={6} sm={12} xs={12}>

                                        <Label item title="Confirm Password" size={12} mandatory={true} />
                                        <Grid item lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="confirmPassword"
                                                type="password"
                                                placeholder="Confirm Password"
                                                MaxLength="100"
                                                value={state?.confirmPassword}
                                                onChange={handleChange}
                                                enablePasswordToggle={true}

                                            />
                                            {errorMessages.errorConfirmPassword && (state.password != state.confirmPassword) ? (<FormHelperText style={{ color: "red" }} >
                                                Password does not match
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>



                                    <Grid lg={6} md={6} sm={12} xs={12}>
                                        <Grid row>
                                            <Label item title="Role" size={12} mandatory={true} />
                                            <Grid lg={12} md={12} sm={12}>
                                                <Select
                                                    size="small"
                                                    native
                                                    name="roleId"
                                                    value={state?.roleId}
                                                    onChange={handleSelectChange}
                                                    placeholder="Select"
                                                    label="Select"
                                                    className={classes.selectBaseInput}
                                                >
                                                    {roles.map(option =>
                                                        <option value={option.value}>{option.label}</option>
                                                    )
                                                    }
                                                </Select>
                                                {errorMessages.errorRole && !state.roleId ? (<FormHelperText style={{ color: "red" }} >
                                                    Please select role
                                                </FormHelperText>) : ('')}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item sm={12} md={6} lg={6} xl={6}>
                                        <Label item title="Corporate Owner" size={12} mandatory={false} />
                                        <Grid lg={12} md={12} sm={12} className={classes.switchBtn }>
                                            <Switch
                                                name="isCorporateOwner"
                                                checked={state.isCorporateOwner}
                                                onChange={handleToggle}
                                                color="primary"
                                                inputProps={{ 'aria-label': 'controlled' }}
                                                disabled={isCorporateOwner}
                                            />
                                            {/*{errorMessages.errorEmailAddress && (!state.emailAddress || !validateEmail(state.emailAddress)) ? (<FormHelperText style={{ color: "red" }} >*/}
                                            {/*    Please enter valid email address*/}
                                            {/*</FormHelperText>) : ('')}*/}
                                        </Grid>
                                    </Grid>

                                </Grid>


                                {/* <div style={{ padding: '10px 15px' }}>
                                    <h4>{state.firstName + ' ' + state.lastName}</h4>
                                    <p style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}><span style={{ minWidth: '40px' }}> <img src={Envelope} />  </span> {state?.emailAddress} </p>
                                    <p style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}><span style={{ minWidth: '40px' }}> <img src={CallIcon} /> </span>  {state?.phoneNumber ? formateMdnNumber(state?.phoneNumber) : ''}</p>
                                    <p style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}><span style={{ minWidth: '40px' }}> <img src={CalendarToday} />  </span> {state?.dateOfBirth ? " " + formatDate(state?.dateOfBirth) + ' ' + getAgeByDOBInYears(state.dateOfBirth, ' | ') : ''}</p>
                                </div> */}

                            </div>

                            {/*<Grid item lg={12} md={12} sm={12} xs={12}>*/}
                            {/*    <div className={classes.whiteBox}>*/}


                            {/*        <Grid container className={classes.formContaner}>*/}
                            {/*            <Grid lg={6} md={6} sm={6} xs={6}>*/}

                            {/*                <Grid row>*/}
                            {/*                    <Label item title="Pin Code" size={12} />*/}
                            {/*                    <Grid lg={12} md={12} sm={12}>*/}
                            {/*                        <InputBaseField*/}
                            {/*                            name="pinCode"*/}
                            {/*                            type="text"*/}
                            {/*                            placeholder="Pin Code"*/}
                            {/*                            MaxLength={4}*/}
                            {/*                            value={state.pinCode}*/}
                            {/*                            onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                            {/*                            onChange={handleDigitFieldChange}*/}
                            {/*                        />*/}
                            {/*                        */}{/*{errorMessages.errorPhoneNumber && !state.phoneNumber ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                        */}{/*    Please enter phone number*/}
                            {/*                        */}{/*</FormHelperText>) : ('')}*/}
                            {/*                    </Grid>*/}
                            {/*                </Grid>*/}
                            {/*            </Grid>*/}

                            {/*            <Grid lg={6} md={6} sm={6} xs={6}>*/}
                            {/*                <Grid row>*/}
                            {/*                    <Label item title="Date of birth" size={12} mandatory={true} />*/}
                            {/*                    <Grid lg={12} md={12} sm={12}>*/}
                            {/*                        <InputBaseField*/}
                            {/*                            name="dateOfBirth"*/}
                            {/*                            type="date"*/}
                            {/*                            placeholder="Date of birth"*/}
                            {/*                            MaxLength="100"*/}
                            {/*                            value={state.dateOfBirth}*/}
                            {/*                            onChange={handleChangeWithTrim}*/}
                            {/*                        />*/}

                            {/*                        {errorMessages.errorDOB && !state.dateOfBirth ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                            Please enter date of birth*/}
                            {/*                        </FormHelperText>) : ('')}*/}
                            {/*                        {errorMessages.errorDOBFuture && state.dateOfBirth > toDayDate() ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                            Date of birth cannot be in future*/}
                            {/*                            */}{/* Date of Birth can not be in the future  */}
                            {/*                        </FormHelperText>) : ('')}*/}
                            {/*                    </Grid>*/}
                            {/*                </Grid>*/}
                            {/*            </Grid>*/}

                            {/*            <Grid lg={6} md={6} sm={6} xs={6}>*/}
                            {/*                <Grid row>*/}
                            {/*                    <Label item title="Gender" size={12} mandatory={true} />*/}
                            {/*                    <Grid lg={12} md={12} sm={12}>*/}
                            {/*                        <Select*/}
                            {/*                            size="small"*/}
                            {/*                            native*/}
                            {/*                            name="gender"*/}
                            {/*                            value={state?.gender}*/}
                            {/*                            onChange={handleSelectChange}*/}
                            {/*                            placeholder="Select"*/}
                            {/*                            label="Select"*/}
                            {/*                            className={classes.selectBaseInput}*/}
                            {/*                        >*/}
                            {/*                            {Gender.map(option =>*/}
                            {/*                                <option value={option.value}>{option.label}</option>*/}
                            {/*                            )*/}
                            {/*                            }*/}
                            {/*                        </Select>*/}
                            {/*                        {errorMessages.errorGender && !state.gender ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                            Please select gender*/}
                            {/*                        </FormHelperText>) : ('')}*/}
                            {/*                    </Grid>*/}
                            {/*                </Grid>*/}
                            {/*            </Grid>*/}
                            {/*            <Grid lg={6} md={6} sm={6} xs={6}>*/}
                            {/*                <Grid row>*/}
                            {/*                    <Label item title="Role" size={12} mandatory={true} />*/}
                            {/*                    <Grid lg={12} md={12} sm={12}>*/}
                            {/*                        <Select*/}
                            {/*                            size="small"*/}
                            {/*                            native*/}
                            {/*                            name="roleId"*/}
                            {/*                            value={state?.roleId}*/}
                            {/*                            onChange={handleSelectChange}*/}
                            {/*                            placeholder="Select"*/}
                            {/*                            label="Select"*/}
                            {/*                            className={classes.selectBaseInput}*/}
                            {/*                        >*/}
                            {/*                            {roles.map(option =>*/}
                            {/*                                <option value={option.value}>{option.label}</option>*/}
                            {/*                            )*/}
                            {/*                            }*/}
                            {/*                        </Select>*/}
                            {/*                        {errorMessages.errorRole && !state.roleId ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                            Please select Role*/}
                            {/*                        </FormHelperText>) : ('')}*/}
                            {/*                    </Grid>*/}
                            {/*                </Grid>*/}
                            {/*            </Grid>*/}


                            {/*        </Grid>*/}

                            {/*        <h3> Address </h3>*/}
                            {/*        <Grid container className={classes.formContaner}>*/}

                            {/*            <Grid lg={6} md={6} sm={12} xs={12} className="p-right-ten">*/}

                            {/*                <Grid row>*/}
                            {/*                    <Label item title="Address Line 1" size={12} mandatory={true} />*/}
                            {/*                    <InputBaseField*/}
                            {/*                        name="address1"*/}
                            {/*                        type="text"*/}
                            {/*                        placeholder="Address Line 1"*/}
                            {/*                        MaxLength={200}*/}
                            {/*                        value={state?.address1}*/}
                            {/*                        onChange={handleChangeWithTrim}*/}
                            {/*                    />*/}
                            {/*                    {errorMessages.errorAddress1 && !state.address1 ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                        Please enter address1*/}
                            {/*                    </FormHelperText>) : ('')}*/}
                            {/*                </Grid>*/}



                            {/*            </Grid>*/}

                            {/*            <Grid lg={6} md={6} sm={12} xs={12} >*/}

                            {/*                <Grid row>*/}
                            {/*                    <Label item title="Address Line 2" size={12} />*/}
                            {/*                    <InputBaseField*/}
                            {/*                        name="address2"*/}
                            {/*                        type="text"*/}
                            {/*                        placeholder="Address Line 2"*/}
                            {/*                        MaxLength={200}*/}
                            {/*                        onChange={handleChangeWithTrim}*/}
                            {/*                        value={state?.address2}*/}
                            {/*                    />*/}
                            {/*                    {errorMessages.errorAddress2 && !state.address2 ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                        Please enter address1*/}
                            {/*                    </FormHelperText>) : ('')}*/}
                            {/*                </Grid>*/}



                            {/*            </Grid>*/}
                            {/*        </Grid>*/}

                            {/*        <Grid container className={classes.formContaner}>*/}
                            {/*            <Grid item lg={4} md={4} sm={4} className="p-right-ten">*/}
                            {/*                <Grid row>*/}
                            {/*                    <Label item title="City" size={12} mandatory={true} />*/}
                            {/*                    <InputBaseField*/}
                            {/*                        name="city"*/}
                            {/*                        type="text"*/}
                            {/*                        placeholder="City"*/}
                            {/*                        MaxLength={50}*/}
                            {/*                        onChange={handleChangeWithTrim}*/}
                            {/*                        value={state?.city}*/}
                            {/*                    />*/}
                            {/*                    {errorMessages.errorCity && !state.city ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                        Please enter city*/}
                            {/*                    </FormHelperText>) : ('')}*/}
                            {/*                </Grid>*/}
                            {/*            </Grid>*/}
                            {/*            <Grid item lg={4} md={4} sm={4}>*/}
                            {/*                <Grid row>*/}
                            {/*                    <Label item title="State" size={12} mandatory={true} />*/}
                            {/*                    <Select*/}
                            {/*                        size="small"*/}
                            {/*                        native*/}
                            {/*                        name="state"*/}
                            {/*                        value={state?.state}*/}
                            {/*                        onChange={handleSelectChange}*/}
                            {/*                        placeholder="Select"*/}
                            {/*                        label="Select"*/}
                            {/*                        className={classes.selectBaseInput}*/}
                            {/*                    >*/}
                            {/*                        {lstStates.map(option =>*/}
                            {/*                            <option value={option.value}>{option.label}</option>*/}
                            {/*                        )*/}
                            {/*                        }*/}
                            {/*                    </Select>*/}

                            {/*                    {errorMessages.errorState && !state.state ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                        Please select state*/}
                            {/*                    </FormHelperText>) : ('')}*/}
                            {/*                </Grid>*/}

                            {/*            </Grid>*/}

                            {/*            <Grid item lg={4} md={4} sm={4}>*/}
                            {/*                <Grid row>*/}
                            {/*                    <Label item title="Zip code" size={12} mandatory={true} />*/}
                            {/*                    <InputBaseField*/}
                            {/*                        name="zipCode"*/}
                            {/*                        type="text"*/}
                            {/*                        placeholder="Zip Code"*/}
                            {/*                        MaxLength={9}*/}
                            {/*                        value={state?.zipCode}*/}
                            {/*                        onChange={handleDigitFieldChange}*/}
                            {/*                        onKeyPress={(e) => handleNumberKeyPress(e)}*/}
                            {/*                    />*/}
                            {/*                    {errorMessages.errorZipCode && !state.zipCode ? (<FormHelperText style={{ color: "red" }} >*/}
                            {/*                        Please enter zip*/}
                            {/*                    </FormHelperText>) : ('')}*/}
                            {/*                </Grid>*/}
                            {/*            </Grid>*/}


                            {/*        </Grid>*/}


                            {/*    </div>*/}
                            {/*</Grid >*/}
                        </div>
                    </Scrollbars>

                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} onClick={updateUserProfileDetails}>{data.userId ? "Update" : "Add New"}</Button>
                        </div>
                    </div>

                </div>

            </div >
            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />
        </Dialog >
    )
}

export default withSnackbar(AddNewUser);
